const pl = {
  modules: {
    sessionWatcher: {
      reason: 'Sesja wygasła! Zaloguj się ponownie.'
    }
  }
};

export default pl;
